import flatpickr from 'flatpickr';
import "flatpickr/dist/themes/material_blue.css";

///////////////////////////////////////////////////////////////////
//
// Event Listeners
//
///////////////////////////////////////////////////////////////////

(function() {
  document.addEventListener('turbolinks:load', (e) => {
    const datePickerElements = document.querySelectorAll('.datepicker,.datetimepicker'),
          linkToAddRecordWithDates = document.querySelector('.add-record-with-dates');

    if (datePickerElements) {
      datePickerElements.forEach(function(element) {
        invokeFlatpickr(element);
        registerOnChangeEvents(element);
      });
    }

    if (linkToAddRecordWithDates) {
      linkToAddRecordWithDates.addEventListener('click', function() {
        document.querySelectorAll('.datepicker,.datetimepicker').forEach(function(element) {
          // Only invoke on newly appended date/datetime fields to avoid overwriting
          // persisted date/datetime values on existing date/datetime fields
          if (element.value == '') {
            invokeFlatpickr(element);
            registerOnChangeEvents(element);
          }
        });
      });
    }
  });



  ///////////////////////////////////////////////////////////////////
  //
  // Callbacks
  //
  ///////////////////////////////////////////////////////////////////

  ///////////////////////////////////////////////
  //
  // Description - Set config for given date input field
  //               and invoke flatpickr
  //
  // Default values may be set via the data-default-datetime property
  // on the date input. The special value 'now' will use the current
  // date/datetime. Specific timestamps may be used as well.
  //
  // If the data-default-datetime property is omitted, the input will
  // be left blank.
  //
  function invokeFlatpickr(element) {
    let maxDateAttribute = element.getAttribute('data-max-date'),
        fpInstance;

    if (maxDateAttribute == null) {
      maxDateAttribute = defaultMaxDate();
    }

    const configDatetime = {
      allowInput: true,
      dateFormat: 'Y-m-d h:i K',
      enableTime: true,
      maxDate: maxDateAttribute
    };

    // The indentation gets gnarly here if we combine these declarations.
    // eslint-disable-next-line one-var
    const configDate = {
      allowInput: true,
      dateFormat: 'Y-m-d',
      maxDate: maxDateAttribute,
    };

    // eslint-disable-next-line one-var
    const defaultDateTimeAttribute = element.getAttribute('data-default-datetime');


    if (element.classList.contains('datetimepicker')) {
      fpInstance = flatpickr(element, configDatetime);
    } else if (element.classList.contains('datepicker')) {
      fpInstance = flatpickr(element, configDate);
    }

    if (element.value == '') {
      // The element doesn't have a value, so set to default if available.

      if (defaultDateTimeAttribute == 'now') {
        fpInstance.setDate(Date.now());
      } else {
        fpInstance.setDate(defaultDateTimeAttribute);
      }
    }
  }



  ///////////////////////////////////////////////
  //
  // Description - The datetime has been changed
  //               (possibly by typing it in), so update
  //               the timestamp shown in the calendar widget.
  //
  function registerOnChangeEvents(element) {
    element.addEventListener('change', function(e) {
      const target = e.target,
            currentDatetime = target.value;

      target._flatpickr.setDate(currentDatetime);
    });
  }

  function defaultMaxDate() {
    return new Date().fp_incr(1826); // 5 years into future including today
  }
})();
